module.exports = __webpack_public_path__ + "static/media/Office Desk.3a41147a.jpg";